@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.passcode.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mifos_mobile.feature.passcode.generated.resources/"

internal val Res.string.feature_passcode_authenticate: StringResource by lazy {
      StringResource("string:feature_passcode_authenticate", "feature_passcode_authenticate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184, 73),
      ))
    }

internal val Res.string.feature_passcode_authenticate_tip: StringResource by lazy {
      StringResource("string:feature_passcode_authenticate_tip", "feature_passcode_authenticate_tip", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 173),
      ))
    }

internal val Res.string.feature_passcode_common_continue: StringResource by lazy {
      StringResource("string:feature_passcode_common_continue", "feature_passcode_common_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 266, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258, 52),
      ))
    }

internal val Res.string.feature_passcode_common_try_again: StringResource by lazy {
      StringResource("string:feature_passcode_common_try_again", "feature_passcode_common_try_again", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 319, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311, 53),
      ))
    }

internal val Res.string.feature_passcode_confirm: StringResource by lazy {
      StringResource("string:feature_passcode_confirm", "feature_passcode_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 389, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 365, 68),
      ))
    }

internal val Res.string.feature_passcode_setup: StringResource by lazy {
      StringResource("string:feature_passcode_setup", "feature_passcode_setup", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 952, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 860, 66),
      ))
    }

internal val Res.string.feature_passcode_setup_failure: StringResource by lazy {
      StringResource("string:feature_passcode_setup_failure", "feature_passcode_setup_failure", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 673, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 605, 46),
      ))
    }

internal val Res.string.feature_passcode_setup_failure_msg: StringResource by lazy {
      StringResource("string:feature_passcode_setup_failure_msg", "feature_passcode_setup_failure_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 466, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 434, 170),
      ))
    }

internal val Res.string.feature_passcode_setup_successful: StringResource by lazy {
      StringResource("string:feature_passcode_setup_successful", "feature_passcode_setup_successful", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 898, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 802, 57),
      ))
    }

internal val Res.string.feature_passcode_setup_successful_msg: StringResource by lazy {
      StringResource("string:feature_passcode_setup_successful_msg", "feature_passcode_setup_successful_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 720, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 652, 149),
      ))
    }

internal val Res.string.feature_passcode_tip: StringResource by lazy {
      StringResource("string:feature_passcode_tip", "feature_passcode_tip", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1027, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 927, 140),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_passcode_authenticate", Res.string.feature_passcode_authenticate)
  map.put("feature_passcode_authenticate_tip", Res.string.feature_passcode_authenticate_tip)
  map.put("feature_passcode_common_continue", Res.string.feature_passcode_common_continue)
  map.put("feature_passcode_common_try_again", Res.string.feature_passcode_common_try_again)
  map.put("feature_passcode_confirm", Res.string.feature_passcode_confirm)
  map.put("feature_passcode_setup", Res.string.feature_passcode_setup)
  map.put("feature_passcode_setup_failure", Res.string.feature_passcode_setup_failure)
  map.put("feature_passcode_setup_failure_msg", Res.string.feature_passcode_setup_failure_msg)
  map.put("feature_passcode_setup_successful", Res.string.feature_passcode_setup_successful)
  map.put("feature_passcode_setup_successful_msg", Res.string.feature_passcode_setup_successful_msg)
  map.put("feature_passcode_tip", Res.string.feature_passcode_tip)
}
